import { render, staticRenderFns } from "./tzprivacy.vue?vue&type=template&id=e49cb276&scoped=true&"
import script from "./tzprivacy.vue?vue&type=script&lang=js&"
export * from "./tzprivacy.vue?vue&type=script&lang=js&"
import style0 from "./tzprivacy.vue?vue&type=style&index=0&id=e49cb276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49cb276",
  null
  
)

export default component.exports